// eslint-disable-next-line jira/import-whitelist
import fetchIssueGiraData from '@atlassian/jira-issue-fetch-services/src/services/issue-gira-data/index.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';

const getData = async ({ match }: RouterDataContext, _storeContext: ResourceStoreContext) => {
	const issueKey = getIssueKey(match);

	if (!issueKey) {
		return null;
	}

	try {
		const data = await fetchIssueGiraData(issueKey);
		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.issue-view.gira.getData',
				message: 'An error was thrown while prefetching issue gira data',
				name: 'ResourceError',
			},
			error,
		);
	}
};

export default getData;
